package gr.tech.meetinggenie.models.meeting

import kotlinx.serialization.Serializable

@Serializable
data class ProjectUpdateDTO(
    var accountName: String = "",
    var whatChanged: String = ""  // paragraph; skip if no change
)
